import { NgModule } from "@angular/core";

import { BfxNucleusSvgComponent } from "shared/branding/bfx-nucleus.component";
import { BfxTitleSvgComponent } from "shared/branding/bfx-title.component";
import { BfxLogoSvgComponent } from "shared/branding/bfx-logo.component";

/**
 * Provides global branding components
 */
@NgModule({
  imports: [],
  providers: [],
  declarations: [BfxNucleusSvgComponent, BfxTitleSvgComponent, BfxLogoSvgComponent],
  exports: [BfxNucleusSvgComponent, BfxTitleSvgComponent, BfxLogoSvgComponent],
})
export class BrandingComponentsModule {}
